import { IconsProps } from '../icon-types';
import { SvgWrapper } from '../svg-wrapper/icon-wrapper';

export function CartOutlineIcon(props: IconsProps) {
  return (
    <SvgWrapper {...props}>
      <path
        d="M5.295 3.33c.329 0 .613.223.694.539l.007.03.743 3.542h14.545c.443 0 .777.397.707.83l-.005.028-1.37 6.771a.716.716 0 01-.671.573H7.579a.716.716 0 01-.693-.538l-.007-.03L4.714 4.761H2V3.33h3.295zM20.41 8.872H7.04l1.121 5.34h11.168l1.081-5.34zm-9.917 7.31a2.241 2.241 0 00-2.237 2.245 2.241 2.241 0 002.237 2.245 2.241 2.241 0 002.238-2.245 2.241 2.241 0 00-2.238-2.245zm0 1.346c.492 0 .893.402.893.899s-.4.9-.893.9a.896.896 0 01-.892-.9c0-.497.4-.9.892-.9zm6.846-1.346a2.241 2.241 0 00-2.237 2.245 2.241 2.241 0 002.237 2.245 2.241 2.241 0 002.238-2.245 2.241 2.241 0 00-2.238-2.245zm0 1.346c.493 0 .893.402.893.899s-.4.9-.893.9a.896.896 0 01-.892-.9c0-.497.4-.9.892-.9z"
        fill="inherit"
        fillRule="evenodd"
      />
    </SvgWrapper>
  );
}
